import type { Project } from '@/lib/mockData'
import { isPresaleSoldOut } from '@/lib/presale/math'
import { listSimPresales } from '@/lib/presale/store'
import { simPresaleToProject } from '@/lib/presale/toProject'

export function listPresaleProjects(): Project[] {
  return listSimPresales().map(simPresaleToProject)
}

export function listLivePresaleProjects(): Project[] {
  return listSimPresales()
    .filter(presale => !isPresaleSoldOut(presale))
    .map(simPresaleToProject)
}

export function listSoldOutPresaleProjects(): Project[] {
  return listSimPresales()
    .filter(isPresaleSoldOut)
    .map(simPresaleToProject)
    .sort((a, b) => b.raised - a.raised)
}

export function getPresaleProjectById(id: string): Project | undefined {
  const key = id.trim().toLowerCase()
  const live = listSimPresales().find((item) => {
    return item.id === id
      || item.id.toLowerCase() === key
      || item.contractAddress?.toLowerCase() === key
      || item.shareSlug?.toLowerCase() === key
  })
  return live ? simPresaleToProject(live) : undefined
}
